// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ele-form-upload-file .el-upload__tip{line-height:1.5}.ele-form-upload-file .el-upload-list__item:first-child{margin-top:5px}", ""]);
// Exports
module.exports = exports;
